angular.module( 'acme.view.application.pricing.categories', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.pricing.categories.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var pricingCategories = {
        name: 'application.pricing.categories',
        url: '/categories',
        views: {
          "subview-main@application": {
            controller: 'PricingCategoriesController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/pricing/categories/categories.tpl.html'
          }
        },
        data: {
          pageTitle: 'Ticket Categories',
          permissions: ['PERSON_TYPES_VIEW']
        }
      };

    $stateProvider
      .state(pricingCategories);
});
